import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";

const data = [
    { month: "May", revenue: 42, projects: 28 },
    { month: "Jun", revenue: 50, projects: 34 },
    { month: "Jul", revenue: 47, projects: 31 },
    { month: "Aug", revenue: 63, projects: 42 },
    { month: "Sep", revenue: 70, projects: 47 },
    { month: "Oct", revenue: 84, projects: 55 },
    { month: "Nov", revenue: 92, projects: 61 },
];

function CustomLegend({ payload }) {
    return (
        <div className="flex items-center justify-center gap-6 pt-3">
            {payload.map((entry, index) => (
                <div key={index} className="flex items-center gap-2">
                    <span
                        className="w-2.5 h-2.5 rounded-full"
                        style={{ backgroundColor: entry.color }}
                    />
                    <span className="text-sm text-slate-500 font-medium">
                        {entry.value}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default function RevenueChart() {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={data}
                margin={{ top: 25, right: 20, left: 0, bottom: 10 }}
            >
                <CartesianGrid
                    strokeDasharray="4 4"
                    stroke="#EEF1F5"
                    vertical={false}
                />

                <XAxis
                    dataKey="month"
                    tick={{ fontSize: 13, fill: "#94A3B8" }}
                    axisLine={false}
                    tickLine={false}
                    dy={10}
                />

                <YAxis
                    tick={{ fontSize: 13, fill: "#94A3B8" }}
                    axisLine={false}
                    tickLine={false}
                />

                <Tooltip
                    contentStyle={{
                        borderRadius: 12,
                        border: "1px solid #E5E7EB",
                        boxShadow: "0 8px 20px rgba(15,23,42,0.08)",
                        fontSize: 13,
                    }}
                    cursor={{ stroke: "#CBD5E1", strokeDasharray: "4 4" }}
                />

                <Legend content={<CustomLegend />} />

                <Line
                    type="monotone"
                    dataKey="revenue"
                    name="Revenue (₹L)"
                    stroke="#7C3AED"
                    strokeWidth={3}
                    dot={{ r: 4, strokeWidth: 3, fill: "#fff", stroke: "#7C3AED" }}
                    activeDot={{ r: 6 }}
                />

                <Line
                    type="monotone"
                    dataKey="projects"
                    name="Projects"
                    stroke="#06B6D4"
                    strokeWidth={3}
                    dot={{ r: 4, strokeWidth: 3, fill: "#fff", stroke: "#06B6D4" }}
                    activeDot={{ r: 6 }}
                />
            </LineChart>
        </ResponsiveContainer>
    );
}